module.exports = __webpack_public_path__ + "media/bootstrap-icons/patch-exclamation-fill-65bf1e59.svg";